import React, { Component } from 'react';
import { Table, Button, Modal } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

@inject('store')
@observer
export class StrategyTable extends Component {
    render() {
        let strategies = [];

        switch (this.props.type) {
            case 'mako_long':
                strategies = this.props.store.strategyStore.makoLong;
                break;
            case 'mako_short':
                strategies = this.props.store.strategyStore.makoShort;
                break;

            default: //noop
        }

        return (
            <Table
                rowKey={'_id'}
                dataSource={strategies}
                columns={[
                    {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                        sorter: (a, b) => {
                            if (a.name < b.name) return -1;
                            if (a.name > b.name) return 1;
                            return 0;
                        },
                        render: (text, o) => (
                            <Link to={`/a/strategies/mako/${o._id}`}>
                                {!text ? 'Untitled' : text}
                            </Link>
                        )
                    },
                    {
                        title: 'Actions',
                        dataIndex: 'actions',
                        render: (text, o) => {
                            return (
                                <div>
                                    <Button
                                        type={'primary'}
                                        onClick={() => {
                                            this.props.store.strategyStore.clone(o, true);
                                            this.props.performDataRefresh();
                                        }}
                                    >
                                        Clone
                                    </Button>
                                </div>
                            );
                        }
                    }
                ]}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/MakoStrategies/Overview/StrategyTable.js